// Styles
import './MessageBanner.scss';

// Libs
import React from 'react';

// PropTypes
import {
  MessageBannerDefaultProps,
  MessageBannerPropTypes,
} from './MessageBanner.proptypes';
// Hooks
import useMessageBanner from './useMessageBanner';

const MessageBanner = ({ children, className, type }) => {
  const { classNames } = useMessageBanner({ className, type });

  return (
    <div className={classNames} data-qa-id="message-banner">
      {children}
    </div>
  );
};

MessageBanner.defaultProps = {
  ...MessageBannerDefaultProps,
};

MessageBanner.propTypes = {
  ...MessageBannerPropTypes,
};

export default MessageBanner;
